import React, { useState, useRef } from "react"; // Importar useRef
import { Button } from "primereact/button"; // Importar Button de PrimeReact
import { fetchWithAuth, API_URL } from "./fetchWithAuth"; // Usar el fetch con autenticación existente y la URL de la API
import "../styles/UploadDocumento.css"; // Importar el archivo CSS
import LoadingOverlay from "./LoadingOverlay";

const UploadDocumento = ({ idReferencia: propIdReferencia, onUploadSuccess }) => {
  // Recibir idReferencia y onUploadSuccess como props
  const fileInputRef = useRef(null); // Referencia para el input de archivo
  const [selectedFile, setSelectedFile] = useState(null);
  const [idReferencia, setIdReferencia] = useState(propIdReferencia || ""); // Usar propIdReferencia si está disponible
  const [tipoDocumento, setTipoDocumento] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]); // Tomar solo el primer archivo seleccionado
    setMessage("");
    setError("");
  };

  const handleIdReferenciaChange = (event) => {
    setIdReferencia(event.target.value);
  };

  const handleTipoDocumentoChange = (event) => {
    setTipoDocumento(event.target.value);
  };

  const handleButtonClick = () => {
    fileInputRef.current.click(); // Simular clic en el input de archivo oculto
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      setError("Por favor, selecciona un archivo para subir.");
      return;
    }
    if (!tipoDocumento) {
      setError("Por favor, ingresa el tipo de documento.");
      return;
    }

    const formData = new FormData();
    formData.append("documento", selectedFile);
    formData.append("idReferencia", idReferencia);
    formData.append("tipoDocumento", tipoDocumento);

    setLoading(true);
    try {
      // Usar fetchWithAuth para manejar la autenticación
      const response = await fetchWithAuth(`${API_URL}/api/upload_documento`, {
        method: "POST",
        body: formData,
        // No es necesario establecer 'Content-Type' para FormData, el navegador lo hace automáticamente
      });

      if (response.ok) {
        const data = await response.json();
        setMessage(data.message);
        setError("");
        setSelectedFile(null); // Limpiar el archivo seleccionado
        setIdReferencia(propIdReferencia || ""); // Restablecer a la prop inicial o vacío
        setTipoDocumento("");
        if (fileInputRef.current) {
          fileInputRef.current.value = ""; // Limpiar el input de archivo
        }
        if (onUploadSuccess) {
          onUploadSuccess(); // Llamar al callback de éxito
        }
      } else {
        const errorData = await response.json();
        setError(errorData.error || "Error al subir el documento.");
        setMessage("");
      }
    } catch (err) {
      console.error("Error al subir el documento:", err);
      setError("Error de red o del servidor.");
      setMessage("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="upload-documento-container">
      <h2>Subir Documentos (Excel/PDF)</h2>
      <div className="form-field-group">
        <label htmlFor="idReferencia" className="form-label">
          ID de Referencia:
        </label>
        <div className="input-wrapper">
          <input
            type="text"
            id="idReferencia"
            value={idReferencia}
            onChange={handleIdReferenciaChange}
            placeholder="Ej: ID de Pedido o Contenedor"
            disabled={!!propIdReferencia} // Deshabilitar si viene de una prop
            className="input-short"
          />
        </div>
      </div>
      <div className="form-field-group">
        <label htmlFor="tipoDocumento" className="form-label">
          Tipo de Documento:
        </label>
        <div className="input-wrapper">
          <input
            type="text"
            id="tipoDocumento"
            value={tipoDocumento}
            onChange={handleTipoDocumentoChange}
            placeholder="Ej: BL, Lista de Empaque, Factura"
            className="input-short"
          />
        </div>
      </div>
      <div className="upload-buttons-container p-field p-d-flex p-ai-center p-gap-2">
        {" "}
        {/* Añadir clases para flexbox y espacio */}
        <Button
          label={selectedFile ? selectedFile.name : "Seleccionar Archivo"}
          icon="pi pi-file"
          className="p-button-secondary"
          onClick={handleButtonClick}
        />
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          style={{ display: "none" }} // Ocultar el input original
        />
        <Button
          label="Subir Documento"
          icon="pi pi-upload"
          className="p-button-success"
          onClick={handleUpload}
          disabled={!selectedFile || !tipoDocumento} // Deshabilitar si no hay archivo o tipo de documento
        />
      </div>
      {message && <p style={{ color: "green" }}>{message}</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}
      {loading && <LoadingOverlay message="Subiendo documento..." />}
    </div>
  );
};

export default UploadDocumento;
